import { useToast } from '@chakra-ui/react'

interface ToastAtributtes {
    title: string
    description?: string
    status: 'error' | 'success'
}

const useToastMessages = () => {
    const toast = useToast()

    const emitToast = (atributes: ToastAtributtes) => {
        const message = 'Algo deu errado, tente novamente mais tarde.'

        toast({
            title: atributes.title,
            description: atributes.description
                ? atributes.description
                : atributes.status == 'error'
                ? message
                : '',
            position: 'bottom-left',
            status: atributes.status,
            isClosable: true
        })
    }

    return {
        emitToast
    }
}

export default useToastMessages
